import { parseOrderStatus } from '@/api/mappers/mapOrder';
import {
  OrderAttentionItem as ApiOrderAttentionItem,
  OrderAttentionListResponse as ApiOrderAttentionListResponse,
} from '@/gen/api';
import {
  OrderAttentionItem,
  OrderAttentionItems,
  OrderAttentionKind,
} from '@/models/OrderAttention';
import { OrderIncompleteDeliveryReason } from '@/models/OrderIncompleteDelivery';

const parseKind = (kind: string): OrderAttentionKind => {
  switch (kind) {
    case OrderAttentionKind.IncompleteDelivery:
      return OrderAttentionKind.IncompleteDelivery;
    case OrderAttentionKind.UnactionedOrder:
      return OrderAttentionKind.UnactionedOrder;
    default:
      return OrderAttentionKind.UnactionedOrder;
  }
};

const parseIncompleteReason = (
  reason?: string | null,
): OrderIncompleteDeliveryReason | null | undefined => {
  if (reason === null || reason === undefined) return reason;

  switch (reason) {
    case OrderIncompleteDeliveryReason.ItemsMissing:
      return OrderIncompleteDeliveryReason.ItemsMissing;
    case OrderIncompleteDeliveryReason.ItemDamaged:
      return OrderIncompleteDeliveryReason.ItemDamaged;
    case OrderIncompleteDeliveryReason.Other:
      return OrderIncompleteDeliveryReason.Other;
    default:
      return undefined;
  }
};

export const toOrderAttentionItem = (item: ApiOrderAttentionItem): OrderAttentionItem => ({
  kind: parseKind(item.kind),
  orderId: item.orderId,
  orderCode: item.orderCode,
  storeId: item.storeId,
  storeName: item.storeName,
  status: parseOrderStatus(item.status),
  occurredAt: item.occurredAt,
  hoursWaiting: item.hoursWaiting,
  incompleteDeliveryId: item.incompleteDeliveryId,
  incompleteReason: parseIncompleteReason(item.incompleteReason),
  lastStatusChangedAt: item.lastStatusChangedAt,
});

export const toOrderAttentionItems = (
  response: ApiOrderAttentionListResponse,
): OrderAttentionItems => ({
  items: response.items.map(toOrderAttentionItem),
  totalCount: response.totalCount,
  estimatedTotalCount: response.estimatedTotalCount,
});
